import React, { useEffect, useState } from 'react';
import styles from './Map.module.css';
import { MapContainer, TileLayer } from 'react-leaflet';

/**
 * @param {{center?: {lat: number, lng: number} | { lat: 29.798707863118377, lng: -98.29839841752587 }, zoom?: number | 0, minZoom?: number | 5, maxZoom?: number | 18, satellite?: boolean, satelliteSwitch?: boolean, setView?: {lat: number, lng: number}}}
 */
export default function Map({
  children,
  className,
  ref,
  center = { lat: 29.798707863118377, lng: -98.29839841752587 },
  zoom = 0,
  minZoom = 5,
  maxZoom = 18,
  satellite = false,
  satelliteSwitch = false,
  setView,
}) {
  return (
    <MapContainer
      className={className}
      ref={ref}
      center={center}
      zoom={zoom}
      minZoom={minZoom}
      maxZoom={maxZoom}
      setView={setView}
    >
      {/* Street map */}
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      />

      {children}
    </MapContainer>
  );
}
